"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert = void 0;
// TODO convertAsync
/**
 * Convert a `value` of any depth using converter.
 * @param guard type-guard used for coercion
 * @param value value to be coerced
 * @param converter custom converter
 */
function convert(guard, value, converter) {
    return guard.convert([], value, converter);
}
exports.convert = convert;
